import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Feb 03 2020
 * @author TSv
 */
import * as React from 'react';
import { Utils } from '@logio/common-be-fe';
import Filter from './Filter';
import FormGroup from '../../../../forms/FormGroup/FormGroup';
import CheckBoxGroup from '../../../../inputs/CheckBoxGroup';
import translate from '../../../../i18n/translate';
import FilterWrapper from './FilterWrapper';
var PromoPriceStatsFilterOption;

(function (PromoPriceStatsFilterOption) {
  PromoPriceStatsFilterOption["YES"] = "Yes";
  PromoPriceStatsFilterOption["NO"] = "No";
  PromoPriceStatsFilterOption["NOT_AVAILABLE"] = "---";
})(PromoPriceStatsFilterOption || (PromoPriceStatsFilterOption = {}));

var PROMO_PRICE_STATS_FILTER_OPTIONS = [PromoPriceStatsFilterOption.YES, PromoPriceStatsFilterOption.NO, PromoPriceStatsFilterOption.NOT_AVAILABLE];
/**
 * Filter for Price zone promo column
 */

var PromoPriceStatsFilter =
/*#__PURE__*/
function (_Filter) {
  _inherits(PromoPriceStatsFilter, _Filter);

  function PromoPriceStatsFilter() {
    var _this;

    _classCallCheck(this, PromoPriceStatsFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoPriceStatsFilter).apply(this, arguments));
    _this.state = {
      valueType: PROMO_PRICE_STATS_FILTER_OPTIONS
    };
    /**
     * This function set filter state from setColumnState() input and similar
     * @param model data input
     */

    _this.setModel = function (model) {
      return _this.setState({
        valueType: model ? model.valueType : PROMO_PRICE_STATS_FILTER_OPTIONS
      }, _this.props.filterChangedCallback);
    };

    _this.onCheckBoxGroupChange = function (valueType) {
      return _this.setState({
        valueType: valueType
      }, _this.props.filterChangedCallback);
    };
    /**
     * Resets input values and clears filter
     */


    _this.onClear = function () {
      return _this.setState({
        valueType: PROMO_PRICE_STATS_FILTER_OPTIONS
      }, _this.closePopup);
    };

    return _this;
  }
  /**
   * This function determines whenever column's filter is active
   */


  _createClass(PromoPriceStatsFilter, [{
    key: "isFilterActive",
    value: function isFilterActive() {
      var _this2 = this;

      return this.state.valueType !== null && this.state.valueType !== undefined && !PROMO_PRICE_STATS_FILTER_OPTIONS.every(function (value) {
        return _this2.state.valueType.includes(value);
      });
    }
    /**
     * This function determines whenever each node passes the filter
     */

  }, {
    key: "doesFilterPass",
    value: function doesFilterPass(params) {
      var value = this.props.valueGetter(params.node);

      if (Utils.isValueMissing(value)) {
        return this.state.valueType.includes(PromoPriceStatsFilterOption.NOT_AVAILABLE);
      }

      if (value.currentPrices.size > 0) {
        return this.state.valueType.includes(PromoPriceStatsFilterOption.YES);
      }

      return this.state.valueType.includes(PromoPriceStatsFilterOption.NO);
    }
    /**
     * This function is for getColumnState() output and similar
     */

  }, {
    key: "getModel",
    value: function getModel() {
      return {
        valueType: this.state.valueType
      };
    }
    /**
     * Renders filter component
     */

  }, {
    key: "render",
    value: function render() {
      return React.createElement(FilterWrapper, {
        onApply: this.onApply,
        onClear: this.onClear
      }, React.createElement(FormGroup, {
        noLabel: true
      }, React.createElement(CheckBoxGroup, {
        values: this.state.valueType,
        name: "alert-checkboxgroup-filter",
        options: [{
          label: translate('yes'),
          value: PromoPriceStatsFilterOption.YES
        }, {
          label: translate('no'),
          value: PromoPriceStatsFilterOption.NO
        }, {
          label: translate('filter-blank'),
          value: PromoPriceStatsFilterOption.NOT_AVAILABLE
        }],
        onChange: this.onCheckBoxGroupChange
      })));
    }
  }]);

  return PromoPriceStatsFilter;
}(Filter);

export { PromoPriceStatsFilter as default };